import { callApi } from "repoV2/utils/common/api/callApi";
import { CALL_API_METHODS } from "repoV2/constants/apis";
import { express_interest_api } from "../ExpressInterest.api";
import { IPostExpressInterestPayload } from "./CreateExpressInterestApi.interfaces";

export const callPostExpressInterestApi = (
    expressInterestPayload: IPostExpressInterestPayload
) =>
    callApi({
        url: `${express_interest_api.create}`,
        method: CALL_API_METHODS.POST,
        data: expressInterestPayload,
        extraOptions: {
            appendExlyBackendHeaders: true,
        },
    });
